import Vue from "vue"
import Vuetify from "vuetify/lib"

import colors from "vuetify/lib/util/colors"
import sk from "./sk.js"

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  lang: {
    locales: { sk: sk },
    current: "sk"
  },
  theme: {
    themes: {
      light: {
        primary: "#3f51b5",
        secondary: "#2196f3",
        accent: "#009688",
        error: "#ff5722",
        warning: "#ff9800",
        info: "#4caf50",
        success: "#795548"
      },
      dark: {
        primary: colors.blue.darken1
      }
    },

    dark: false
  }
})
